import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setisLogging } from '../store/authSlice';
import { useEffect, useState } from 'react';
import {useLogs} from '../hooks';

const withGuard = (Component) => {
    
    const Wrapper = (props) =>{
        const dispatch = useDispatch();
        const {resultLogsPost,postDataHandler} = useLogs()
        const getTokenFromPath = () => {
            const pathArray = window.location.pathname.split('/');
            const tokenIndex = pathArray.indexOf('token');
            if(tokenIndex === -1) return null;
            return pathArray[tokenIndex + 1] || null;
        };
        const localToken = localStorage.getItem('token');
        const pathToken = getTokenFromPath();
        const initialToken = pathToken || localToken;
        if(pathToken && pathToken !== localToken){
            localStorage.setItem('token', pathToken);
            localStorage.removeItem('user');
            localStorage.removeItem('userCurrentTs');
        }

        const [hadTokenInitially] = useState(() => Boolean(initialToken));
        const [token,setToken] = useState(() => initialToken);
        const [isTokenExists,setIsTokenExists] = useState(() => Boolean(initialToken));
        const [isLogin,setIsLogin] = useState(false);

        useEffect(() => {
            const tokenFromPath = getTokenFromPath();
            if(tokenFromPath){
                if(tokenFromPath !== token){
                    localStorage.setItem('token', tokenFromPath);
                    localStorage.removeItem('user');
                    localStorage.removeItem('userCurrentTs');
                    setToken(tokenFromPath);
                }
                setIsTokenExists(true);
                return;
            }
            if(token) return;
            setIsTokenExists(false);
        }, [token]);

        useEffect(() => {
            const cachedUserTs = parseInt(localStorage.getItem('userCurrentTs') || '0');
            const cachedUserFresh = cachedUserTs && (Date.now() - cachedUserTs) < 5 * 60 * 1000;
            let cachedUser = null;
            try{
                cachedUser = JSON.parse(localStorage.getItem('user'));
            }catch(e){
                cachedUser = null;
            }

            if(cachedUser && cachedUserFresh) {
                dispatch(setisLogging({user: cachedUser,isLogging: true}));
                setIsLogin(true);
                return;
            }
            if(!token) return;

            let isActive = true;
            (async() => {
                try{
                    const userRes = await axios.get(`${process.env.REACT_APP_Auth_API_BASE_URL}/users/current`,{
                        headers:{'Authorization': 'Bearer ' + token}
                    });
                    if(!isActive) return;
                    if(userRes.data){
                        localStorage.setItem('user', JSON.stringify(userRes.data.data.user));
                        localStorage.setItem('userCurrentTs', Date.now().toString());
                        dispatch(setisLogging({user: userRes.data.data.user,isLogging: true}));
                        setIsLogin(true)
                    }else{
                        window.location.replace(`${process.env.REACT_APP_Auth_WEB_BASE_URL}`)
                    }
                }catch(error){
                    if(!isActive) return;
                    window.location.replace(`${process.env.REACT_APP_Auth_WEB_BASE_URL}`)
                }
            })();

            return () => {
                isActive = false;
            }
        }, [dispatch, token]);

        useEffect(() => {
            if(!isLogin) return;
            if(hadTokenInitially) return;
            if(!isTokenExists) return;
            postDataHandler({
                moduleName: "SALES",
                resourceName: "SALES",
                eventName:"LOGIN",
                logContentEn: `Login user`,
                logContentAr: `تسجيل دخول`,
            });
        }, [hadTokenInitially, isLogin, isTokenExists, postDataHandler]);

        useEffect(()=>{
            if(resultLogsPost && !hadTokenInitially){
                setIsTokenExists(true);
            }
        },[resultLogsPost, hadTokenInitially]);

        if(isLogin && isTokenExists){
            return <Component {...props} /> 
        }
        return null;
    }
    return Wrapper;
}

export default withGuard
